import React from 'react';

interface ForwardRefProps {
  id: any,
  children: any
}

const Section = React.forwardRef((props: ForwardRefProps, ref: any) => (
  <section id={props.id} ref={ref} className="section">
    {props.children}
  </section>
));

export default Section;
